require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-emedicinehealth-prevention.json") })
        }
      }, "path---article-emedicinehealth-prevention");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-emedicinehealth-prevention!./.cache/json/article-emedicinehealth-prevention.json
// module id = 341
// module chunks = 231608221292675